import React from 'react'
import { useModal, ModalProps } from './useModal'
import styles from './Modal.module.scss'

const Modal: React.FC<ModalProps> = (props: ModalProps) => {
  const {
    title,
    btnSubmitLabel,
    btnSubmitBgColor,
    btnSubmitTextColor,
    children,
    hideFooter,
    isVisible,
    isCentered,
    isBtnSubmitDisabled,
    bgColor,
    titleColor,
    handleClose,
  } = useModal(props)

  return (
    <div
      className={`${styles.modal} modal ${
        isVisible ? 'show' : ''
      } fade d-block`}
      tabIndex={-1}
      role='dialog'
    >
      <div
        className={`${styles.dialog} modal-dialog ${
          isCentered ? 'modal-dialog-centered' : ''
        } modal-lg`}
        style={{ backgroundColor: bgColor || 'rgba(20, 24, 39, 0.85)' }}
        role='document'
      >
        <div className={`modal-content ${styles.content}`}>
          <div className={`modal-header ${styles.header}`}>
            <h5 className='modal-title' style={{ color: titleColor || '#fff' }}>
              {title}
            </h5>
            <button
              type='button'
              className={`btn-close ${styles['btn-close']}`}
              style={{ color: titleColor || '#fff' }}
              aria-label='Close'
              onClick={handleClose}
            ></button>
          </div>
          <div className={`modal-body ${styles.body}`}>{children}</div>
          {!hideFooter && (
            <div className={`modal-footer ${styles.footer}`}>
              <button
                type='submit'
                className={`btn btn-primary ${styles['btn-primary']} w-100`}
                style={{
                  backgroundColor: btnSubmitBgColor || 'var(--landing-primary)',
                  borderColor: btnSubmitBgColor || 'var(--landing-primary)',
                  color: btnSubmitTextColor || 'var(--landing-default)',
                }}
                disabled={isBtnSubmitDisabled}
              >
                {btnSubmitLabel}
              </button>
            </div>
          )}
        </div>
      </div>
      <div
        className={`${styles.backdrop} modal-backdrop fade ${
          isVisible ? 'show' : ''
        }`}
        onClick={handleClose}
      />
    </div>
  )
}

export default Modal
